export default "__VITE_ASSET__BP6NhXCa__"